"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@autoprog/theme/dist/theme.css");
require("../css/app.css");
const acadio_icon_full_opacity_svg_raw_1 = __importDefault(require("@assets/icon/acadio-icon-full-opacity.svg?raw"));
/**
 * Renvoie le theme actuel entre 'dark', 'light' ou null.
 * @returns le thème actuel
 */
const getTheme = () => {
    return localStorage.getItem('Acadio_Theme');
};
/**
 * Applique le theme sur la page
 */
const applyTheme = () => {
    const theme = getTheme();
    const N_Body = document.querySelector('body');
    const N_HTML = document.querySelector('html');
    if (theme) {
        N_Body.setAttribute('data-acadio-theme', theme);
        N_HTML.style.colorScheme = theme;
    }
    else {
        N_Body.removeAttribute('data-acadio-theme');
    }
};
/**
 * Initialise le message d'erreur
 */
const initErrorMessage = () => {
    const N_ErrorMessage = document.querySelector('#error-message');
    N_ErrorMessage.innerHTML = '';
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const error = urlParams.get('error');
    if (error === 'WRONG_LOGIN_OR_PASSWORD') {
        N_ErrorMessage.innerHTML = 'Identifiant ou mot de passe incorrect.';
    }
};
/**
 * Initialise le formattage du formulaire
 */
const initFormFormat = () => {
    const N_InputLogin = document.querySelector('#input-login');
    N_InputLogin.addEventListener('change', () => {
        N_InputLogin.value = N_InputLogin.value.trim().toLowerCase();
    });
    N_InputLogin.addEventListener('input', () => {
        N_InputLogin.value = N_InputLogin.value.trim().toLowerCase();
    });
};
/**
 * Initialise la fonctionnalité afficher/masquer le mot de passe
 */
const initPasswordToggle = () => {
    const N_ToggleBtn = document.querySelector('#toggle-password-visibility');
    const N_InputPass = document.querySelector('#login-pass');
    if (N_ToggleBtn && N_InputPass) {
        N_ToggleBtn.addEventListener('click', () => {
            // 1. On bascule le type de l'input
            const isPassword = N_InputPass.type === 'password';
            N_InputPass.type = isPassword ? 'text' : 'password';
            // 2. On bascule la classe pour changer l'icône via le CSS
            N_ToggleBtn.classList.toggle('is-visible');
            // 3. Optionnel : On remet le focus sur l'input pour une meilleure UX
            N_InputPass.focus();
        });
    }
};
/**
 * Fonction d'initialisation principale
 */
const initIcon = () => {
    const N_Icon = document.querySelector('#app-icon');
    if (N_Icon)
        N_Icon.innerHTML = acadio_icon_full_opacity_svg_raw_1.default;
};
const init = () => {
    applyTheme();
    initIcon();
    initErrorMessage();
    initFormFormat();
    initPasswordToggle();
};
init();
